// "Remove background" (B / button): one photo → auto mode now; several → the batch queue (§11.12).
import { useEditor } from '../../state/editor';
import { useLibrary } from '../../state/library';
import { autoMatte, removeBackgroundBatch, useMatte } from './matte';

export async function removeBackground(ids: string[]): Promise<void> {
  if (!ids.length) return;
  if (ids.length > 1) {
    await removeBackgroundBatch(ids);
    return;
  }
  const id = ids[0]!;
  useEditor.getState().update(id, (s) => void (s.background.mode = 'auto'));
  const p = useLibrary.getState().photos.find((x) => x.id === id);
  if (!p) return;
  try {
    await autoMatte(p);
  } finally {
    useMatte.setState((st) => ({ version: st.version + 1 }));
  }
}
